import React, { useState, useEffect } from 'react';
import moment from 'moment';
import DatePicker, { registerLocale } from 'react-datepicker';
import CustomTimeInput from '../shared/CustomTimeInput';
import sv from 'date-fns/locale/sv';
registerLocale('sv', sv);

const DatePickers = ({ onChange, firstInvoiceMonth }) => {
    const [startDate, setStartDate] = useState(
        moment()
            .subtract(window.innerWidth < 900 ? 2 : 5, 'month')
            .startOf('month')
            .toDate()
    );
    const [endDate, setEndDate] = useState(
        moment()
            .subtract(1, 'month')
            .startOf('month')
            .toDate()
    );

    const updateStartDate = (date) => {
        setStartDate(date);
        if (endDate < date) setEndDate(date);
    };

    useEffect(() => {
        const start = moment(startDate).format('YYYYMM');
        const end = moment(endDate).format('YYYYMM');

        onChange({ startDate: start, endDate: end });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [endDate, startDate]);

    const minDate = firstInvoiceMonth && moment(firstInvoiceMonth, 'YYYYMM').toDate();

    return (
        <div className='d-flex justify-content-between align-items-center'>
            <span>
                <DatePicker
                    selected={startDate}
                    onChange={(date) => updateStartDate(date)}
                    dateFormat='yyyy-MM'
                    customInput={<CustomTimeInput />}
                    showMonthYearPicker
                    minDate={minDate}
                    maxDate={new Date()}
                    locale='sv'
                />
            </span>
            <span className='oi oi-arrow-right px-md-3 px-1'></span>
            <span>
                <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    dateFormat='yyyy-MM'
                    customInput={<CustomTimeInput />}
                    showMonthYearPicker
                    minDate={startDate}
                    maxDate={new Date()}
                    locale='sv'
                    popperPlacement='bottom-end'
                />
            </span>
        </div>
    );
};

export default DatePickers;
